import { IsCustomVariableValid } from "../contacts";

export const CleanTextRegex = /[^\p{L}\p{N}\p{P}\p{S} ]/gu;
export const phoneNumberLooseRegex =
  /^(\s)*(\+?\d{1,4}?[\s.-]?)?((\(\d{1,5}\))|\d{1,5})[\s.-]?\d{1,5}([\s.-]?\d{1,5}){1,4}(\s)*$/;
export const emailRegex =
  /^(?:[a-zA-Z0-9._\+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,63})?[ ]?$/;
export const EMAIL_REQUIRED_REGEX =
  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,63}$/;
export const stateRegex = /^([A-Z]{2})?[ ]?$/i;
export const zipRegex = /^(\d{5}(-\d{4})?)?[ ]?$/;
export const nameLooseRegex = /^(?!\s*$)[\p{L}\s'-]+$/u;
const FIELD_REGEX = /@\[([\w\s]+)\]\(([\w\s]+)\)/g;

export const GetDynamicContentBE = (
  str: string | undefined,
  overrides?: { [key: string]: string }
): string => {
  if (str === undefined || !str) {
    return "";
  }

  let result = str;

  const matches = result.match(FIELD_REGEX);

  if (matches) {
    matches.forEach((match) => {
      const variable = match.substring(
        match.indexOf("(") + 1,
        match.indexOf(")")
      );
      result = result.replace(
        match,
        (overrides || {})[variable] ?? `{${variable}}`
      );
    });
  }

  return result.trim();
};

export const GetDynamicContentUI = (
  str: string | undefined,
  variables: string[],
  t?: (val: string) => string
): string => {
  if (str === undefined || !str) {
    return "";
  } else if (variables.length === 0) {
    return str;
  }

  let result = str;

  result = result
    .replaceAll("{fname}", "{first_name}")
    .replaceAll("{lname}", "{last_name}")
    .replaceAll(
      "{agencyname}",
      variables.includes("business_name") ? "{business_name}" : "{agency_name}"
    )
    .replaceAll(
      "{agency_name}",
      variables.includes("business_name") ? "{business_name}" : "{agency_name}"
    );

  const regex = new RegExp(variables.map((v) => `{${v}}`).join("|"), "gi");
  const matches = result.match(regex);

  if (matches) {
    matches.forEach((match) => {
      let variable = match.replace("{", "").replace("}", "");
      result = result.replace(
        match,
        `@[${t ? t(variable) : variable}](${variable})`
      ); //"@[Agency Name](Agency Name)"
    });
  }

  return result;
};

export const UpdateDynamicContentUI = (
  str: string | undefined,
  ct: (str: string) => string
): string => {
  if (str === undefined || !str) {
    return "";
  }

  let result = str;

  // First find correctly formatted variables - @[display](variable_id)
  // This regex looks for display names followed by variable IDs that include underscores
  const validRegex = /@\[([\w\s]+)\]\(([\w\s]+)\)/g;
  const validMatches = result.match(validRegex);

  if (validMatches) {
    validMatches.forEach((match) => {
      const variablePart = match.substring(
        match.indexOf("(") + 1,
        match.indexOf(")")
      );

      // Update display text with proper translation, but keep the variable ID
      result = result.replace(match, `@[${ct(variablePart)}](${variablePart})`);
    });
  }

  // We do not fix or modify invalid variables, so they can be highlighted in red

  return result;
};
